const DodoneLink = ({ dodoneId, children, onNav, className = '' }) => {
  if (!dodoneId) return null

  return (
    <Link to={`/dodones/${dodoneId}`} className={className} onClick={onNav}>
      {children}
    </Link>
  )
}

export default DodoneLink
